<template>
  <v-dialog
    v-model="isOpenInner"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span>Добавление нового проекта</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-text-field
            required
            v-model="project"
            label="Название проекта"
            :hint="slugProject"
            :rules="[required]"
          ></v-text-field>
          <v-select
            required
            v-model="checkUsers"
            :items="innerUsers"
            item-text="user"
            chips
            label="Пользователи"
            multiple
          ></v-select>
          <v-file-input
            v-model="files"
            label="Файл XLSX для загрузки..."
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :rules="[required]"
          ></v-file-input>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="isOpenInner = false">Закрыть</v-btn>
        <v-btn text color="success" @click="addProject" :disabled="!valid">Создать</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import asyncQuery from "../../../asyncQuery";

  const slugSimb = {
    а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'yo', ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l',
    м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'c', ч: 'ch', ш: 'sh',
    щ: 'shch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya', ' ': '_',
  };
  export default {
    name: "AddProjectDialog",
    data: () => {
      return {
        valid: false,

        project: '',
        files: null,
        checkUsers: [],
      }
    },
    props: {
      isOpen: Boolean,
      toggleAddProjectDialog: Function,
      toggleLoading: Function,
      getProjects: Function,
      users: Array,
      getAllUsers: Function,
      showMessage: Function,
    },
    mounted() {
      this.getAllUsers()
    },
    computed: {
      slugProject: function () {
        let slugProject = '';
        for (const i in this.project) {
          const simb = this.project[i].toLowerCase();
          slugProject += slugSimb[simb] !== undefined
            ? simb.replace(simb, slugSimb[simb])
            : simb;
        }
        return slugProject
      },
      isOpenInner: {
        get: function () {
          return this.isOpen;
        },
        set: function () {
          this.toggleAddProjectDialog();
        }
      },
      innerUsers: function () {
        return this.users.filter(el => el.roles.indexOf('admin'))
      },
    },
    methods: {
      // валидация полей
      required: value => !!value || 'Это обязательное поле.',

      addProject: function () {
        const data = new FormData();
        data.append('file', this.files);
        data.append('project', this.project);
        data.append('slugProject', this.slugProject);
        if (this.checkUsers) data.append('users', this.checkUsers);

        asyncQuery.bind(this)({
          url: '/api/add_project',
          method: 'POST',
          body: data,
          form: true,
          handleSuccess: () => {
            this.getProjects();
            this.toggleAddProjectDialog();
            this.$data.project = '';
            this.$data.files = [];
            this.$data.users = [];
            this.$data.checkUsers = [];
          },
          handleStatus: {
            400: json => {
              this.showMessage(json.message, 'error');
            },
          }
        })
      },
    },
  }
</script>
